export const MAJOR_CITIES = ["montreal", "laval", "longueuil", "quebec-city", "gatineau", "sherbrooke", "trois-rivieres", "saguenay"];

export const CORE_SERVICES = ["security-guards", "mobile-patrol", "event-security", "construction-site-security"];

export const isIndexableCombo = (serviceSlug, citySlug) =>
  MAJOR_CITIES.includes(citySlug) || CORE_SERVICES.includes(serviceSlug);
